export const areCartItemsDuplicates = (item1, item2) => (item2.key !== item1.key &&
    item1.product_id === item2.product_id &&
    !((item1.variant_title === item2.variant_title &&
        item1.final_price !== item2.final_price) || (item1.product_type === 'custom' &&
        ((item1.properties._userImageLink !== item2.properties._userImageLink ||
            item1.properties._hexagonImages !== item2.properties._hexagonImages ||
            item1.properties._setImages !== item2.properties._setImages ||
            item1.properties._collageImages !== item2.properties._collageImages) ||
            item1.options_with_values[0].value !== item2.options_with_values[0].value))));
